import type SVGProps from '~/components/icons/svg-props'

export type CheckIconProps = SVGProps & {
  variant?: 'outlined' | 'filled'
}

export default function CheckIcon(props: CheckIconProps) {
  const { variant, ...rest } = props
  return variant === 'filled' ? (
    <CheckIconFilled width="16" height="16" {...rest} />
  ) : (
    <CheckIconOutlined width="16" height="16" {...rest} />
  )
}

function CheckIconOutlined(props: SVGProps) {
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3991 6.82749C10.5734 6.65311 10.5734 6.3704 10.3991 6.19602C10.2247 6.02165 9.94197 6.02165 9.7676 6.19602L7.10659 8.85704L6.23162 7.98207C6.05725 7.8077 5.77453 7.8077 5.60016 7.98207C5.42578 8.15645 5.42578 8.43916 5.60016 8.61353L6.79085 9.80423C6.96523 9.97861 7.24794 9.97861 7.42232 9.80423L10.3991 6.82749Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99961 1.60013C4.46499 1.60013 1.59961 4.46551 1.59961 8.00013C1.59961 11.5348 4.46499 14.4001 7.99961 14.4001C11.5342 14.4001 14.3996 11.5348 14.3996 8.00013C14.3996 4.46551 11.5342 1.60013 7.99961 1.60013ZM2.49263 8.00013C2.49263 4.95871 4.95819 2.49315 7.99961 2.49315C11.041 2.49315 13.5066 4.95871 13.5066 8.00013C13.5066 11.0415 11.041 13.5071 7.99961 13.5071C4.95819 13.5071 2.49263 11.0415 2.49263 8.00013Z"
        fill="currentColor"
      />
    </svg>
  )
}

function CheckIconFilled(props: SVGProps) {
  return (
    <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z"
        fill="currentColor"
      />
    </svg>
  )
}
